<template>
  <div id="detalhes-da-solicitacao" class="dados-da-solicitacao">
    <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />

    <div class="logos print has-text-centered">
      <img src="../../../assets/imagens/logo-relatorio-retrato.jpg" />
    </div>
    <h2 class="print title-print">Detalhes da solicitação</h2>

    <div class="container container_com-fundo container_com-margem">
      <cabecalho-da-solicitacao
        :nome-do-titular="nomeDoTitular"
        :subsidio-da-agehab="subsidioDaAgehab"
        :acoes-da-situacao="acoesDaSituacao"
        :pode-autorizar-pagamento="podeAutorizarPagamento()"
        :pode-editar="podeEditar()"
        :pode-alterar-nup="podeAlterarNup()"
        :solicitacao-eh-do-bonus-moradia="solicitacaoEhDoBonusMoradia"
        :linha-do-tempo="solicitacao.LinhaDoTempo"
        @executar-acao="executarAcaoDaSituacao"
        @abrir-pagamento="abrirModalDeConfirmacaoDePagamento"
        @editar="redirecionarParaEdicao"
        @abrir-alteracao-nup="abrirModalDeAlteracaoDeNup"
      />
    </div>

    <div style="margin-left: 16px; margin-right: 16px">
      <alerta
        v-if="situacaoDoPrazoDoDossie && situacaoDoPrazoDoDossie.textoDoBanner"
        tipo="perigo"
        :titulo="situacaoDoPrazoDoDossie.textoDoBanner"
        :texto="situacaoDoPrazoDoDossie.descricaoDoBanner"
      />
    </div>

    <abas-detalhes-solicitacao
      :aba-selecionada="abaSelecionada"
      :total-de-itens-na-linha-do-tempo="historicoDoStatus ? historicoDoStatus.length : 0"
      @update:abaSelecionada="abaSelecionada = $event"
    />

    <div v-if="abaSelecionada === 'visao-geral'" class="secao-visao-geral">
      <protocolo-da-solicitacao
        :existe-numero-do-processo="existeNumeroDoProcesso"
        :numero-do-processo="numeroDoProcesso"
        :operacao-bancaria="operacaoBancaria"
        :operacao-bancaria-complementar="operacaoBancariaComplementar"
        :origem-da-assinatura="origemDaAssinatura"
        :status="status"
        :situacao-do-prazo-do-dossie="situacaoDoPrazoDoDossie"
        @prorrogar="abrirModalDeProrrogacao"
      />

      <div class="grade-de-cards">
        <dados-do-proponente
          :proponentes="proponentes"
          :renda-total="rendaTotal"
          :renda-total-comprovada="rendaTotalComprovada"
        />

        <dados-do-imovel
          :construtora="construtora"
          :cidade="cidade"
          :empreendimento="empreendimento"
          :imovel="imovel"
          :valor-da-compra-e-venda="valorDaCompraEVenda"
          :participacao-do-solicitante="participacaoDoSolicitante"
          :valor-do-financiamento-aprovado="valorDoFinanciamentoAprovado"
          :subsidio-da-agehab="subsidioDaAgehab"
          :subsidio-do-governo-federal="subsidioDoGovernoFederal"
          :fgts-do-solicitante="fgtsDoSolicitante"
          :desconto-da-construtora="descontoDaConstrutora"
          :solicitacao-eh-do-bonus-moradia="solicitacaoEhDoBonusMoradia"
        />
      </div>
    </div>

    <div v-if="abaSelecionada === 'linha-do-tempo'" class="container_com-margem">
      <linha-do-tempo :itens="itensDaLinhaDoTempo" tags-grandes />
    </div>

    <dialogo-de-situacao
      v-if="acaoEmAndamento"
      :situacao-atual="status"
      :acao="acaoEmAndamento"
      :carregando="loading.visivel"
      @fechar="fecharDialogoDeSituacao"
      @confirmar="confirmarAcaoDaSituacao"
    />

    <modal-autorizar-pagamento
      v-if="modalDeConfirmacaoDePagamentoEstaVisivel"
      :carregando="loading.visivel"
      @fechar="fecharModalDeConfirmacaoDePagamento"
      @confirmar="onConfirmarPagamento"
    />

    <modal-alterar-nup
      v-if="modalDeAlteracaoDeNupEstaVisivel"
      :carregando="loading.visivel"
      :projeto-exige-numero-do-processo="projetoExigeNumeroDoProcesso"
      @fechar="fecharModalDeAlteracaoDeNup"
      @confirmar="onConfirmarAlteracaoDeNup"
    />

    <modal-de-prorrogacao
      v-if="modalDeProrrogacaoEstaVisivel"
      :carregando="loading.visivel"
      :estado="situacaoDoPrazoDoDossie && situacaoDoPrazoDoDossie.estado"
      :prazo-do-dossie="prazoDoDossie"
      @fechar="fecharModalDeProrrogacao"
      @confirmar="onConfirmarProrrogacao"
    />

    <MensagemFlutuante
      :mensagemVisivel="mensagemVisivel"
      :titulo="tituloMensagem"
      :estilo="estiloMensagem"
      :texto="textoMensagem"
      @close="fecharMensagem"
    />
  </div>
</template>

<script>
import Alerta from '../../shared/Alerta';
import DialogoDeSituacao from '../../shared/DialogoDeSituacao';
import LinhaDoTempo from '../../shared/LinhaDoTempo';
import Loading from '../../shared/Loading';
import MensagemFlutuante from '../../shared/MensagemFlutuante';
import AbasDetalhesSolicitacao from './components/AbasDetalhesSolicitacao';
import CabecalhoDaSolicitacao from './components/CabecalhoDaSolicitacao';
import DadosDoImovel from './components/DadosDoImovel';
import DadosDoProponente from './components/DadosDoProponente';
import ModalAlterarNup from './components/ModalAlterarNup';
import ModalAutorizarPagamento from './components/ModalAutorizarPagamento';
import ModalDeProrrogacao from './components/ModalDeProrrogacao';
import ProtocoloDaSolicitacao from './components/ProtocoloDaSolicitacao';
import mixinSolicitacao from './mixinSolicitacao';

export default {
  name: 'detalhes-da-solicitacao',
  mixins: [mixinSolicitacao],
  components: {
    Alerta,
    Loading,
    MensagemFlutuante,
    LinhaDoTempo,
    DialogoDeSituacao,
    CabecalhoDaSolicitacao,
    AbasDetalhesSolicitacao,
    ProtocoloDaSolicitacao,
    DadosDoProponente,
    DadosDoImovel,
    ModalAutorizarPagamento,
    ModalAlterarNup,
    ModalDeProrrogacao,
  },
  data() {
    return {
      abaSelecionada: 'visao-geral',
      modalDeConfirmacaoDePagamentoEstaVisivel: false,
      modalDeAlteracaoDeNupEstaVisivel: false,
      modalDeProrrogacaoEstaVisivel: false,
    };
  },
  methods: {
    abrirModalDeConfirmacaoDePagamento() {
      this.modalDeConfirmacaoDePagamentoEstaVisivel = true;
    },
    fecharModalDeConfirmacaoDePagamento() {
      this.modalDeConfirmacaoDePagamentoEstaVisivel = false;
    },
    onConfirmarPagamento(dados) {
      this.autorizarPagamento(dados)
        .then(() => {
          this.fecharModalDeConfirmacaoDePagamento();
        })
        .catch(() => {});
    },
    abrirModalDeAlteracaoDeNup() {
      this.modalDeAlteracaoDeNupEstaVisivel = true;
    },
    fecharModalDeAlteracaoDeNup() {
      this.modalDeAlteracaoDeNupEstaVisivel = false;
    },
    onConfirmarAlteracaoDeNup(novoNumeroDoProcesso) {
      this.alterarNup(novoNumeroDoProcesso)
        .then(() => {
          this.fecharModalDeAlteracaoDeNup();
        })
        .catch(() => {});
    },
    abrirModalDeProrrogacao() {
      this.modalDeProrrogacaoEstaVisivel = true;
    },
    fecharModalDeProrrogacao() {
      this.modalDeProrrogacaoEstaVisivel = false;
    },
    onConfirmarProrrogacao(dados) {
      this.prorrogar(dados)
        .then(() => {
          this.fecharModalDeProrrogacao();
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// DetalhesDaSolicitacao.vue?738e9234